/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_RemoveInputs */

const en_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove track`)
};

const fr_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la piste`)
};

const de_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spur entfernen`)
};

const it_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi traccia`)
};

const ru_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить трек`)
};

const es_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar pista`)
};

const zh_cn2_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曲目`)
};

const ja_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラックを削除`)
};

const hi_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक हटाएँ`)
};

const pt_pt2_audio_embed_export_output_remove = /** @type {(inputs: Audio_Embed_Export_Output_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover faixa`)
};

/**
* | output |
* | --- |
* | "Remove track" |
*
* @param {Audio_Embed_Export_Output_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_remove = /** @type {((inputs?: Audio_Embed_Export_Output_RemoveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_RemoveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_remove(inputs)
	if (locale === "de") return de_audio_embed_export_output_remove(inputs)
	if (locale === "it") return it_audio_embed_export_output_remove(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_remove(inputs)
	if (locale === "es") return es_audio_embed_export_output_remove(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_remove(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_remove(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_remove(inputs)
	return en_audio_embed_export_output_remove(inputs)
});